import { useEffect, useState } from 'react';

import i18n from 'i18n-react';

import APIHandler from 'config/APIHandler';

/** @param res */
const parseAdvisorResponse = (res) => {
  if (res === false || res == null) {
    return { data: null, error: i18n.translate('glassWidgets.errors.requestFailed') };
  }
  if (typeof res !== 'object') {
    return { data: null, error: 'Unexpected response' };
  }
  const payload = res;

  if (payload.result === 'success') {
    return { data: res, error: null };
  }

  if (typeof payload.response === 'string') {
    return { data: null, error: payload.response };
  }
  if (typeof payload.message === 'string') {
    return { data: null, error: payload.message };
  }
  return { data: null, error: 'Request failed' };
};

/**
 * Loads advisor dashboard payload via APIHandler.getAdvisorDashboardData (single request for glass widgets).
 *
 * @param {string | number} appId
 * @param {string} email User email; sent to the dashboard API (Quark auth via query param, no bearer token).
 * @param {string} [langCode='en-US']
 */
const useAdvisorDashboardData = (appId, email, langCode = 'en-US') => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (appId == null || appId < 0) {
      setData(null);
      setError(null);
      setIsLoading(false);
      return undefined;
    }

    const normalizedEmail = typeof email === 'string' ? email.trim() : '';
    if (!normalizedEmail) {
      setData(null);
      setError(null);
      setIsLoading(false);
      return undefined;
    }

    let cancelled = false;
    setIsLoading(true);
    setError(null);

    const fetchAdvisorDashboardData = async () => {
      const raw = await APIHandler.getAdvisorDashboardData(appId, normalizedEmail, langCode);
      if (cancelled) return;
      const { data: next, error: err } = parseAdvisorResponse(raw);
      setData(next);
      setError(err);
      setIsLoading(false);
    };

    fetchAdvisorDashboardData();

    return () => {
      cancelled = true;
    };
  }, [appId, email, langCode]);

  return { data, error, isLoading };
};

export default useAdvisorDashboardData;
